var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fullLayout"},[(_vm.isLogoShow ==='')?_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"Vue logo","src":require('@/assets/img/logo.png')}})])],1):_vm._e(),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }